<template>
  <div>
    <p @click="show_popup">
      <i class="el-icon-circle-plus-outline"></i>
      <span>Add user</span>
    </p>
  </div>
</template>

<script>
export default {
  name: "AddUserToProject",
  props: {
    project_id: [String, Number],
    project_name: [String, Number],
  },
  methods: {
    show_popup() {
      this.$root.$emit("addRenameProjectAddUser", this.project_id);
    },
  },
};
</script>
